import { log } from "./log";
import { client } from "./supabase";

// Lectura/escritura de `alertas_recurrencia_descartadas`. La tabla base + RLS ya está aplicada en
// producción (migración 20260925d); la columna `posponer_hasta` es la que sigue ESCRITA SIN
// APLICAR (10.137, migración 20260926) — mientras no exista, `cargarDescartes` recibe error de
// PostgREST al pedirla, devuelve `null` (mismo camino que "tabla no existe"), y el botón
// "Postergar" del panel no se muestra — las otras 3 vías de apagado siguen funcionando igual.
//
// Ya NO existe el descarte permanente (Fase 3 del rediseño, 2026-09-26): toda fila representa una
// postergación con vencimiento. `postergarAlerta` es un UPSERT, no un INSERT — la PK es
// (pais, empresa_norm, mes, ano), así que postergar de nuevo una empresa que ya había sido
// postergada antes (la postergación anterior venció y volvió a aparecer) actualiza la MISMA fila en
// vez de chocar contra la PK.

export const cargarDescartes = async ({ pais }) => {
  const { data, error } = await client
    .from("alertas_recurrencia_descartadas")
    .select("empresa_norm, mes, ano, posponer_hasta")
    .eq("pais", pais);
  if (error) {
    log.warn("cargarDescartes", `alertas_recurrencia_descartadas no disponible todavía: ${error.message}`);
    return null;
  }
  return data || [];
};

const DIAS_POSTERGACION = 7;

export const postergarAlerta = async ({ pais, empresaNorm, mes, ano, usuarioId, dias = DIAS_POSTERGACION }) => {
  const posponerHasta = new Date();
  posponerHasta.setDate(posponerHasta.getDate() + dias);
  const { error } = await client.from("alertas_recurrencia_descartadas").upsert(
    {
      pais,
      empresa_norm: empresaNorm,
      mes,
      ano,
      descartado_por: usuarioId,
      descartado_en: new Date().toISOString(),
      posponer_hasta: posponerHasta.toISOString().slice(0, 10),
    },
    { onConflict: "pais,empresa_norm,mes,ano" }
  );
  if (error) {
    log.error("postergarAlerta", error);
    throw error;
  }
};
